export default __webpack_public_path__ + "static/media/Roboto-Bold.4f39c579.ttf";